import React from "react";
import { useStore } from "../../store";
import Personalized from "./Personalized";
import NotPersonalized from "./NotPersonalized";

const CallToActionCard = ({ className }) => {
  const { cta, userDetails } = useStore().home;

  // no cta, don't render anything
  if (!cta || cta.error || !userDetails) {
    return null;
  }

  return (
    <section className={className}>
      {userDetails.isPersonalized ? (
        <Personalized cta={cta} userDetails={userDetails} />
      ) : (
        <NotPersonalized
          cta={cta}
          affiliationName={userDetails.affiliationName}
        />
      )}
    </section>
  );
};

export default CallToActionCard;
